import { render, staticRenderFns } from "./habeas-data.vue?vue&type=template&id=629364b8&scoped=true"
import script from "./habeas-data.vue?vue&type=script&lang=js"
export * from "./habeas-data.vue?vue&type=script&lang=js"
import style0 from "./habeas-data.vue?vue&type=style&index=0&id=629364b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629364b8",
  null
  
)

export default component.exports